import React from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';
import logo from '../logo.png';

export default function Header() {
  const inlineHeaderStyle = { background: 'linear-gradient(90deg,#0f172a 0%, #1e3a8a 100%)' };
  return (
    <header className="app-header" style={inlineHeaderStyle}>
      <div className="header-left">
        <img src={logo} alt="logo" className="header-logo" />
        <div>
          <h1 className="header-title">INDIAN</h1>
          <p className="header-subtitle">Pincode Finder</p>
        </div>
      </div>
      <nav className="header-nav">
        <NavLink
          to="/"
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          style={({ isActive }) => ({ color: '#ffffff', background: isActive ? 'linear-gradient(90deg, rgba(96,165,250,0.12), rgba(37,99,235,0.14))' : 'transparent' })}
        >Home</NavLink>
        <NavLink
          to="/pincode"
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          style={({ isActive }) => ({ color: '#ffffff', background: isActive ? 'linear-gradient(90deg, rgba(96,165,250,0.12), rgba(37,99,235,0.14))' : 'transparent' })}
        >Pincode Search</NavLink>
        <NavLink
          to="/about"
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          style={({ isActive }) => ({ color: '#ffffff', background: isActive ? 'linear-gradient(90deg, rgba(96,165,250,0.12), rgba(37,99,235,0.14))' : 'transparent' })}
        >About</NavLink>
        <NavLink
          to="/contact"
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          style={({ isActive }) => ({ color: '#ffffff', background: isActive ? 'linear-gradient(90deg, rgba(96,165,250,0.12), rgba(37,99,235,0.14))' : 'transparent' })}
        >Contact</NavLink>
      </nav>
    </header>
  );
}
